document.addEventListener('DOMContentLoaded', function () {
  var pickButton = document.getElementById('zasilkovna-pick-button');
  var changeButton = document.getElementById('zasilkovna-change-point');
  var selectedBox = document.getElementById('zasilkovna-selected-point');
  var pointNameEl = document.getElementById('zasilkovna-point-name');
  var pointAddressEl = document.getElementById('zasilkovna-point-address');
  var zboxSection = document.getElementById('zasilkovna-zbox-section');
  var addressSection = document.getElementById('zasilkovna-address-section');
  var radios = document.querySelectorAll('input[name="zasilkovna-delivery-type"]');
  var pointSelected = false;

  if (!pickButton) return;

  var apiKey = window.zasilkovnaApiKey;

  function updateWarningMessages() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var freeShipping = cart.item_count >= 2;
        var zboxWarning = document.getElementById('zasilkovna-zbox-warning');
        var addressWarning = document.getElementById('zasilkovna-address-warning');

        if (freeShipping) {
        zboxWarning.classList.add('zasilkovna-free-shipping');
        addressWarning.classList.add('zasilkovna-free-shipping');
        zboxWarning.innerHTML = '🎉 Máte 2 a více kusů — doprava je <strong>zdarma</strong>. V pokladně nezapomeňte vybrat dopravu <strong>„Doručení do Z-BOXu"</strong>.';
        addressWarning.innerHTML = '🎉 Máte 2 a více kusů — doprava je <strong>zdarma</strong>. V pokladně nezapomeňte vybrat dopravu <strong>„Doručení na adresu"</strong>.';
      } else {
        zboxWarning.classList.remove('zasilkovna-free-shipping');
        addressWarning.classList.remove('zasilkovna-free-shipping');
        zboxWarning.innerHTML = '⚠️ V pokladně nezapomeňte vybrat dopravu <strong>„Doručení do Z-BOXu – 99 Kč"</strong>';
        addressWarning.innerHTML = '⚠️ V pokladně nezapomeňte vybrat dopravu <strong>„Doručení na adresu – 139 Kč"</strong>';
      }
      });
  }

  updateWarningMessages();

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (this.value === 'zbox') {
        zboxSection.style.display = 'block';
        addressSection.style.display = 'none';
      } else {
        zboxSection.style.display = 'none';
        addressSection.style.display = 'block';
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { 'Výdejní místo Zásilkovna': '', 'Zásilkovna Point ID': '' }
          })
        });
      }
    });
  });

  function openWidget() {
    Packeta.Widget.pick(apiKey, function (point) {
      if (!point) return;

      pointNameEl.textContent = point.name;
      pointAddressEl.textContent = point.formatedValue || (point.street + ', ' + point.city);
      selectedBox.style.display = 'flex';
      pickButton.style.display = 'none';
      pointSelected = true;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Výdejní místo Zásilkovna': point.name + ' — ' + (point.formatedValue || point.street + ', ' + point.city),
            'Zásilkovna Point ID': point.id
          }
        })
      });
    }, {
      country: 'cz,sk',
      language: 'cs'
    });
  }

  pickButton.addEventListener('click', openWidget);
  if (changeButton) {
    changeButton.addEventListener('click', openWidget);
  }

  document.addEventListener('click', function (e) {
    var isCheckoutLink = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
    if (!isCheckoutLink) return;

    var zboxChosen = document.querySelector('input[name="zasilkovna-delivery-type"]:checked').value === 'zbox';
    if (zboxChosen && !pointSelected) {
      e.preventDefault();
      e.stopPropagation();
      alert('Nejdřív prosím vyberte konkrétní výdejní místo / Z-BOX.');
      document.getElementById('zasilkovna-widget-wrapper').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);
});